// extracted by mini-css-extract-plugin
export default {"featureList":"FeatureList_featureList__WPIHT","title":"FeatureList_title__gtwBu"};